import React from 'react';
import Title from '../title';
import $ from "jquery";
import Server from '../../functions/server';
import Permission from '../../functions/permission';
import Loading from '../loading';
import View from './view';

class BrandControl extends React.Component {

  state = {
    branchandbrand: [], menuPermission:[]
  }

  componentDidMount() {
    this.menuControl();
  }

  menuControl() {
    let menuPermission = Permission('brand-control', this.props.menus);
    if (menuPermission.view) {
      this.getBranchAndBrand();
    }
    this.setState({ menuPermission })
  }

  getBranchAndBrand() {
    let context = this;
    context.setState({
      load: true,
      message: 'Getting Branch And Brand Conrol'
    })
    $.ajax({
      type: 'POST',
      url: Server() + 'branchandbrand/getall.php',
      success: function(data)
      {
        context.setState({
          load: false,
        });
        try {
          data = JSON.parse(data);
          let option = [];
          data.map((c) => {
            if (c.type == 'brand') {
              option.push({ key: c.name, text: c.name, value: c.id })
            }
          })
          context.setState({ branchandbrand: data, brandOption: option })
        } catch (e) {
          context.setState({
            load: false,
          });
        }
      },
      error: function(e)
      {
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    });
  }

  brands(id) {
    let data = this.state.branchandbrand;
    let value = [{}];
    let option = [];
    data.map((x) => {
      if (x.type != 'branch' && x.type != 'brand') {
        if (x.name == id) {
          value.push(x.type);
        }
      }
    })
    return(
      <View menuPermission={this.state.menuPermission} branch={id} option={this.state.brandOption} value={value} getBranchAndBrand={this.getBranchAndBrand.bind(this)} />
    )
  }

  render() {
    let i = 1;
    return (
      <div>
        <Title title={'Brand Control'} openDrawer={this.props.openDrawer}/>
        { this.state.menuPermission.view ?
          (
            <div>
              <Loading load={this.state.load} message={this.state.message} />
              <div style={{padding: '2%'}}>
                <table id='table' width='100%'>
                  <tr>
                    <th id='th' style={{width: '5%'}}><center>Sino</center></th>
                    <th id='th' style={{width: '15%'}}><center>Branch</center></th>
                    <th id='th'><center>Brand</center></th>
                  </tr>
                  { this.state.branchandbrand.map((x) => {
                      if (x.type == 'branch') {
                        return (
                          <tr>
                            <td>{i++}</td>
                            <td>{x.name}</td>
                            <td>{this.brands(x.id)}</td>
                          </tr>
                        )
                      }
                    })

                  }
                </table>
              </div>
            </div>
          ):
          (
            <div>
              <center>You are not allow to access this menu!!!</center>
            </div>
          )
        }
      </div>
    );
  }
}

export default BrandControl;
